//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Diagramming.js";
import "../Diagramming/Diagramming.SheetElementBuilder.js";
import "../no/ugmath.js";
let d=[[[0,"ArrowType",1,0],[0,"StubLength",1,0],[0,"StubSides",1,0],[0,"VerticalAlignment",1,0]],[[["num_points","points"],"GetBendPoints",{},0,0],[["points"],"SetBendPoints",{},1,0],[["terminator","segmentId","percentX","inputX","percentY","inputY"],"SetTerminator",{},6,0],[["terminator","segmentId","percentX","inputX","percentY","inputY"],"GetTerminator",{},0,0]],[]];
SPLM.Diagramming.LeaderLineBuilder = class extends SPLM.Diagramming.SheetElementBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Diagramming.LeaderLineBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Diagramming.LeaderLineBuilder.VerticalAlignmentOption = Object.freeze({
    "Top" : "Top", "Middle" : "Middle", "Bottom" : "Bottom"});

export default SPLM;